<div [ngClass]="loyalty?'main__page':''">
    <ion-refresher slot="fixed" pullFactor="0.5" pullMin="100" pullMax="200" (ionRefresh)="doRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-title *ngIf="!db.ismobile && loyalty && false" class="ion-title">Reward Points</ion-title>

<div class="max-overflow" *ngIf="loyalty" #scrollMe (scroll)="onScroll($event)">
  <div class="d__flex" >
    <div class="wallet__info total_points"> 
        <div class="wallet__title" >{{loyalty &&  loyalty.total_points? (loyalty.total_points | number: '1.0-0'):0  }}</div>
        <div class="wallet__text">Total Points</div>
    </div>
    <div class="wallet__info available_points">
        <div class="wallet__title">{{loyalty && (loyalty.total_available_points | number: '1.0-0') ?loyalty.total_available_points:0 }}</div>
        <div class="wallet__text">Available Points</div>
    </div>
    <div class="wallet__info redeemed_points">
        <div class="wallet__title">{{loyalty && loyalty.redeemed_points?loyalty.redeemed_points:0 }}</div>
        <div class="wallet__text">Redeemed</div>
    </div>  
  </div>
    
    <div class="table__data" *ngIf="loyalty && loyalty.transactions && !db.ismobile"> 
      <div class="order__details">
          <div class="reference">Reference</div>
          <div class="trans__date">Transaction Date</div>
          <div class="points">Points</div>
      </div>
      <div class=" mouse" *ngFor="let item of loyalty.transactions;let i =index">
          <div class="reward__items">
              <div class="reference">{{item.name}}</div>
              <div class="trans__date">{{item.creation  | date:'medium'}}</div>
              <div class="points"> {{item.loyalty_points }}</div>
          </div>
      </div>
  </div>

  <div class="table__data" *ngIf="loyalty && loyalty.transactions && db.ismobile"> 

    <div class=" mouse" *ngFor="let item of loyalty.transactions;let i =index">
        <div class="table__items d__flex just-s">
            <div>
                <div class="fnt-14">{{item.name}}</div>
                <div class="fnt-11">{{item.creation  | date:'medium'}}</div>
            </div>
            <div class="fnt-14" > {{item.loyalty_points  }}</div>
        </div>
    </div>
</div>

</div>
<!-- *ngIf="db.Wallet_points" -->
<div class="reward__img" *ngIf="db.Wallet_points" >
    <img src="assets/icons/Gift-null.svg" alt="">
    <h6 class="m-0 fnt-12 oops-text">No Reward Points Available..!</h6>
</div>
<!--  -->
<div *ngIf="!loyalty && !db.Wallet_points">
  <div class="d__flex just-a p-10">
    <ion-card class="m0 p5 border w-33" *ngFor="let i of [0,1,2]">
      <p class="p10 m0">
        <ion-skeleton-text animated style="width: 100%;height: 100%;"></ion-skeleton-text>
      </p>
      <p class="p10 m0">
        <ion-skeleton-text animated style="width: 100%;height: 100%;"></ion-skeleton-text>
      </p>
    </ion-card>
  </div>
    <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7]">
      <ion-label>
        <h3>
          <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
        </p>
        <!-- <p>
          <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
        </p> -->
      </ion-label>
    </ion-item>
  </div>

</div>
